// Volume Discount Bar - total del carrito + lo que se va a añadir, frente a los tramos de descuento
(function() {
  'use strict';

  class VolumeDiscountBar {
    constructor() {
      this.container = document.querySelector('.volume-discount-bar');
      if (!this.container) return;

      this.price = parseFloat(this.container.dataset.productPrice) || 0;
      this.discountTiers = [
        { amount: 125, discount: 10 },
        { amount: 250, discount: 15 },
        { amount: 450, discount: 20 },
        { amount: 700, discount: 25 },
        { amount: 1000, discount: 30 }
      ];

      this.currentStatus = document.getElementById('discount-current-status');
      this.baseCartTotal = 0;
      this.isUpdating = false;
      this.lastUpdate = 0;
      this.pollTimer = null;
      this.mutationObserver = null;
      
      this.init();
    }

    async init() {
      await this.updateCartTotal();
      this.bindEvents();
      this.updateDisplay();
      this.startPolling();
    }

    // Request optimizado
    async updateCartTotal() {
      const now = Date.now();
      if (this.isUpdating || (now - this.lastUpdate) < 300) return;

      this.isUpdating = true;
      this.lastUpdate = now;

      try {
        const response = await fetch('/cart.js', { cache: 'no-cache' });
        if (!response.ok) throw new Error('Network error');
        
        const cart = await response.json();
        this.baseCartTotal = cart.items.reduce((total, item) => {
          const unitPrice = item.original_price || item.price;
          return total + (unitPrice * item.quantity);
        }, 0) / 100;
      } catch (error) {
        console.warn('Cart update failed:', error.message);
      } finally {
        this.isUpdating = false;
      }
    }

    // Events simplificados
    bindEvents() {
      const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), delay);
        };
      };

      const quickUpdate = debounce(this.handleCartUpdate, 200);
      const slowUpdate = debounce(this.handleCartUpdate, 500);

      const quantityInputs = document.querySelectorAll(
        'input[name="quantity"], .quantity-input input, [data-quantity-input]'
      );
      quantityInputs.forEach(input => {
        input.addEventListener('input', quickUpdate, { passive: true });
        input.addEventListener('change', quickUpdate, { passive: true });
      });

      document.addEventListener('cart:added', quickUpdate, { passive: true });
      document.addEventListener('cart:updated', slowUpdate, { passive: true });
      document.addEventListener('cart:change', slowUpdate, { passive: true });

      this.container.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vdb-add]');
        if (btn) this.addUnits(parseInt(btn.dataset.vdbAdd, 10) || 1);
      });

      this.setupCartDrawer();
    }

    async handleCartUpdate() {
      await this.updateCartTotal();
      this.updateDisplay();
    }

    // Cart drawer simplificado
    setupCartDrawer() {
      const cartSelectors = [
        'cart-drawer', '#cart-drawer', '.cart-drawer', 
        '[data-cart-drawer]', '#CartDrawer'
      ];

      let cartDrawer = null;
      for (const selector of cartSelectors) {
        cartDrawer = document.querySelector(selector);
        if (cartDrawer) break;
      }

      if (!cartDrawer) return;

      const updateHandler = this.debounce(this.handleCartUpdate.bind(this), 300);

      if (window.MutationObserver) {
        try {
          this.mutationObserver = new MutationObserver(mutations => {
            const hasRelevantChanges = mutations.some(mutation => {
              if (mutation.type === 'childList') {
                return mutation.target.closest?.('.cart-items, cart-items');
              }
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                return mutation.target.matches?.('input[name="updates[]"], .qty-input__input');
              }
              return false;
            });

            if (hasRelevantChanges) updateHandler();
          });

          this.mutationObserver.observe(cartDrawer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['value']
          });
        } catch (error) {
          console.warn('MutationObserver setup failed:', error);
        }
      }

      cartDrawer.addEventListener('click', (e) => {
        const target = e.target;
        if (target.matches('.btn--plus, .btn--minus, .qty-input__btn, .js-remove-item, .cart-item__remove')) {
          updateHandler();
        }
      }, { passive: true });

      cartDrawer.addEventListener('input', (e) => {
        if (e.target.matches('.qty-input__input, input[name="updates[]"]')) {
          updateHandler();
        }
      }, { passive: true });
    }

    // Polling reducido
    startPolling() {
      if (this.pollTimer) clearInterval(this.pollTimer);
      
      let lastTotal = this.baseCartTotal;
      let errorCount = 0;
      
      this.pollTimer = setInterval(async () => {
        if (this.isUpdating || errorCount > 2) return;

        try {
          const response = await fetch('/cart.js', { cache: 'no-cache' });
          const cart = await response.json();
          
          const currentTotal = cart.items.reduce((total, item) => {
            const unitPrice = item.original_price || item.price;
            return total + (unitPrice * item.quantity);
          }, 0) / 100;
          
          if (Math.abs(currentTotal - lastTotal) > 0.01) {
            lastTotal = currentTotal;
            this.baseCartTotal = currentTotal;
            this.updateDisplay();
          }
          errorCount = 0;
        } catch (error) {
          errorCount++;
        }
      }, 4000);
    }

    debounce(func, delay) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    }

    getCurrentQuantity() {
      const quantityInput = document.querySelector('input[name="quantity"]') 
        || document.querySelector('.quantity-input input')
        || document.querySelector('[data-quantity-input]');
      
      return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    }

    calculatePotentialTotal() {
      const quantity = this.getCurrentQuantity();
      return this.baseCartTotal + (quantity * this.price);
    }

    calculateSavings(total, discountPercent) {
      return total * (discountPercent / 100);
    }

    // 67.09 -> "67,09 €"; 90 -> "90 €"
    formatMoney(amount) {
      const opts = Number.isInteger(Math.round(amount * 100) / 100) ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
      return amount.toLocaleString('es-ES', opts) + '\u00a0€';
    }

    updateDisplay() {
      const total = this.calculatePotentialTotal();
      const idx = this.getCurrentTierIndex(total);
      this.updateDiscountLevels(idx);
      this.updateCurrentStatus(total, idx);
    }

    // Índice del último tramo alcanzado (-1 si ninguno)
    getCurrentTierIndex(total) {
      let currentTierIndex = -1;
      for (let i = 0; i < this.discountTiers.length; i++) {
        if (total >= this.discountTiers[i].amount) currentTierIndex = i;
        else break;
      }
      return currentTierIndex;
    }

    // Resalta la columna del tramo que tienes (las dos filas de la tabla)
    updateDiscountLevels(idx) {
      this.container.querySelectorAll('.vdb__table tr').forEach((row) => {
        row.querySelectorAll('td').forEach((td, i) => td.classList.toggle('is-current', i === idx));
      });
    }

    // Unidades de ESTE producto que faltan para llegar a un importe (los tramos cuentan todo el carrito).
    unitsTo(amount, total) {
      return this.price > 0 ? Math.max(1, Math.ceil((amount - total) / this.price - 1e-9)) : null;
    }

    // Una frase y un botón. Los importes van CON IVA, como la tabla y los descuentos de Shopify.
    updateCurrentStatus(total, idx) {
      if (!this.currentStatus) return;
      const next = this.discountTiers[idx + 1] || null;
      if (!next) {
        this.currentStatus.innerHTML = `<span>Tienes el descuento máximo, el <strong>−${this.discountTiers[idx].discount} %</strong>.</span>`;
        return;
      }
      const n = this.unitsTo(next.amount, total);
      this.currentStatus.innerHTML = `<span>Te faltan <strong>${this.formatMoney(next.amount - total)}</strong> para el <strong>−${next.discount} %</strong></span>`
        + (n ? `<button type="button" class="vdb__add" data-vdb-add="${n}">+${n} ud${n > 1 ? 's' : ''}.</button>` : '');
    }

    // Botón «+N uds.»: sube la cantidad del selector de la ficha; la barra se repinta con su evento input/change.
    addUnits(n) {
      const input = document.querySelector('input[name="quantity"]') || document.querySelector('.quantity-input input') || document.querySelector('[data-quantity-input]');
      if (!input) return;
      const max = parseInt(input.max, 10);
      let v = (parseInt(input.value, 10) || 1) + n;
      if (max > 0) v = Math.min(v, max);
      input.value = v;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    destroy() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      
    }
  }

  // Inicialización con listener de resize
  let discountBarInstance = null;

  function initDiscountBar() {
    if (discountBarInstance) {
      discountBarInstance.destroy();
    }
    discountBarInstance = new VolumeDiscountBar();
  }

  // NUEVO: Listener para cambios de tamaño de ventana
  let resizeTimeout;
  window.addEventListener('resize', () => {
    if (discountBarInstance) {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        discountBarInstance.updateDisplay();
      }, 150);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountBar);
  } else {
    initDiscountBar();
  }

  document.addEventListener('shopify:section:load', initDiscountBar);

  window.addEventListener('beforeunload', () => {
    if (discountBarInstance) {
      discountBarInstance.destroy();
    }
  });

})();